export const ContentRangeError = new Error(`
  The Content-Range header is missing in the HTTP Response. 
  The Turn REST data provider expects responses for lists of resources to contain this header with 
  the total number of results to build the pagination. 
  If you are using CORS, did you declare Content-Range in the Access-Control-Expose-Headers header? 
`);

export const getTotal = (headers: Headers) => parseInt(headers.get('content-range').split('/').pop(), 10);
